/**
 * Centralized, structured endpoint definitions.
 * All paths are relative to the REACT_APP_API_URL base URL.
 */
export const endpoints = {
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    users: '/auth/users',
    exportUsers: '/auth/users/export',
    roles: '/auth/roles',
  },
  crm: {
    customers: '/crm/customers',
    exportCustomers: '/crm/customers/export',
  },
  collections: {
    catalogs: '/collections/catalogs',
  },
  notifications: {
    push: '/notifications/push',
    whatsappTemplates: '/whatsapp/templates',
    whatsappMessages: '/whatsapp/messages/template',
  },
} as const;
